import createVueComponent from '../createVueComponent';

const Dice3 = createVueComponent('Dice3Icon', [
  [
    'rect',
    {
      width: '18',
      height: '18',
      x: '3',
      y: '3',
      rx: '2',
      ry: '2',
      key: '1m3agn',
    },
  ],
  ['path', { d: 'M16 8h.01', key: 'cr5u4v' }],
  ['path', { d: 'M12 12h.01', key: '1mp3jc' }],
  ['path', { d: 'M8 16h.01', key: '18s6g9' }],
]);

export default Dice3;
